import AssignRetailerAccountModal from './AssignRetailerAccountModal.container'

export default AssignRetailerAccountModal
